// base styles
import "iconoir/css/iconoir.css";
import "./styles/vars.css";
import "./styles/normalize.css";
import "./styles/base.css";

// classes
import "./styles/classes/button.css";
import "./styles/classes/card.css";
import "./styles/classes/chip.css";
import "./styles/classes/fieldset.css";
import "./styles/classes/input.css";
import "./styles/classes/link.css";
import "./styles/classes/loading.css";
import "./styles/classes/noise.css";
import "./styles/classes/popover.css";
import "./styles/classes/progress.css";
import "./styles/classes/skeleton.css";
import "./styles/classes/table.css";
import "./styles/classes/util.css";

// js
import "./window.js";
import "./store.js";

//components
import "./components/datetime.js";
import "./components/datetimeinput.js";
import "./components/dialog.js";
import "./components/icon.js";
import "./components/select.js";
import "./components/pageloader.js";
import "./components/pagination.js";
import "./components/pdfviewer.js";
import "./components/themeswitch.js";
import "./components/sort.js";
import "./components/gallery.js";
import "./components/mdviewer.js";

// navigation
import "./boost/fragment.js";
import "./boost/boost.js";

// for debug
window.addEventListener("keyup", () => {});
